import type {QueryClient} from "@tanstack/react-query";
import {i18n} from "../i18n";
import {SUPPORTED_LANGS} from "../language";
import {clearProjectBundle} from "./bundle";
import {clearProjectQueries} from "./query";

export function resetI18nOnLogout(queryClient: QueryClient) {
    clearProjectBundle(i18n, SUPPORTED_LANGS);
    clearProjectQueries(queryClient);
    console.log("i18n reseted")
}
